module.exports = __webpack_public_path__ + "img/xw-003.45be0185.jpg";